import Vue from 'vue'
import Vuex from 'vuex'
import utils from './utils'
import document from './document'
import customer from './customer'
import job from './job'
import cabinet from './cabinet'
import project from './project'
import vendor from './vendor'
import item from './item'
import user from './user'
import logs from './logs'
import log from './log'
import submenu from './submenu'
import transaction from './transaction'
import task from './task'
import addtask from './addtask'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    utils,
    document,
    customer,
    logs,
    job,
    cabinet,
    vendor,
    item,
    user,
    project,
    log,
    submenu,
    transaction,
    task,
    addtask
  }
})
export default store